import React from 'react';
import Select, { MultiValue } from 'react-select';

interface ApiOption {
  id: string | number;
  name: string;
}

interface SelectOption {
  value: string;
  label: string;
}

interface TenDashboardTableProps {
  formats: ApiOption[];
  programmes: ApiOption[];
  supporters: ApiOption[];
  selectedFormats: MultiValue<SelectOption>;
  selectedProgramme: string;
  selectedSupporters: MultiValue<SelectOption>;
  selectedComparison: string;
  progType: string;
  customStyles: any;
  isGenerating: boolean;
  onFormatsChange: (formats: MultiValue<SelectOption>) => void;
  onProgrammeChange: (programme: string) => void;
  onSupportersChange: (supporters: MultiValue<SelectOption>) => void;
  onComparisonChange: (comparison: string) => void;
  onProgTypeChange: (type: string) => void;
  onGenerateReport: () => void;
}

const TenDashboardTable: React.FC<TenDashboardTableProps> = ({
  formats,
  programmes,
  supporters,
  selectedFormats,
  selectedProgramme,
  selectedSupporters,
  selectedComparison,
  progType,
  customStyles,
  isGenerating,
  onFormatsChange,
  onProgrammeChange,
  onSupportersChange,
  onComparisonChange,
  onProgTypeChange,
  onGenerateReport
}) => {
  const formatOptions: SelectOption[] = formats
    .filter(f => f.name && f.name.trim() !== '')
    .map(f => ({
      value: String(f.id),
      label: f.name.charAt(0).toUpperCase() + f.name.slice(1).toLowerCase()
    }));

  const supporterOptions: SelectOption[] = supporters
    .filter(s => s.name && s.name.trim() !== '')
    .map(s => ({
      value: String(s.id),
      label: s.name
    }));

  return (
    <div className='card shadow-sm border-dark' style={{ borderWidth: '2px' }}>
      <div className='card-body px-5'>
        <table className="table table-borderless align-middle">
          <tbody>
            <tr>
              <td className="fw-bold w-25 align-top pt-3"></td>
              <td>
                <div
                  className="d-flex gap-3 mt-2 text-muted"
                  style={{ fontSize: '0.9rem' }}
                >
                  <span className="d-flex align-items-center">
                    <i className="bi bi-info-circle me-1"></i>
                    Only programme completed
                  </span>

                  <span className="d-flex align-items-center border-start ps-3">
                    <i className="bi bi-calendar-check me-1"></i>
                    Only programme launched after 1.1.2023
                  </span>
                </div>
              </td>
            </tr>

            <tr>
              <td className="fw-bold w-25 align-top pt-3">Formats</td>
              <td>
                <Select
                  isMulti
                  options={formatOptions}
                  value={selectedFormats}
                  onChange={onFormatsChange}
                  placeholder="Select formats..."
                  className="react-select-container"
                  classNamePrefix="select"
                  styles={customStyles}
                />
              </td>
            </tr>

            <tr>
              <td className="fw-bold">Companies</td>
              <td>
                <div className="d-flex gap-4">

                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="progType"
                      id="both"
                      value="both"
                      checked={progType === 'both'}
                      onChange={(e) => onProgTypeChange(e.target.value)}
                    />
                    <label className="form-check-label" htmlFor="both">
                      Both
                    </label>
                  </div>

                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="progType"
                      id="cor2ed"
                      value="cor2ed"
                      checked={progType === 'cor2ed'}
                      onChange={(e) => onProgTypeChange(e.target.value)}
                    />
                    <label className="form-check-label" htmlFor="cor2ed">
                      COR2ED
                    </label>
                  </div>

                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="progType"
                      id="medAffairs"
                      value="medAffairs"
                      checked={progType === 'medAffairs'}
                      onChange={(e) => onProgTypeChange(e.target.value)}
                    />
                    <label className="form-check-label" htmlFor="medAffairs">
                      Medical Affairs
                    </label>
                  </div>

                </div>
              </td>
            </tr>

            <tr>
              <td className="fw-bold align-top pt-3">Supporters</td>
              <td>
                <Select
                  isMulti
                  options={supporterOptions}
                  value={selectedSupporters}
                  onChange={onSupportersChange}
                  placeholder="Select supporters..."
                  className="react-select-container"
                  classNamePrefix="select"
                  styles={customStyles}
                />
              </td>
            </tr>
          </tbody>
        </table>

        <div className='row mt-4'>
          <div className='col-12 text-center'>
            {isGenerating ? (
              <div className="text-justify-content-md-center">
                <span className='indicator-progress text-center' style={{ display: 'block' }}>
                  Generating report...
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              </div>
            ) : (
              <button 
                type="button" 
                className="btn btn-primary btn-lg px-5"
                onClick={onGenerateReport}
              >
                Generate Report
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export { TenDashboardTable };
